export default "__VITE_PUBLIC_ASSET__ce0cfa45__"